export const checkRegEx = (n: string, regex: any) => {
  return (
    regex.reg.test(n) ||
    n === '' ||
    (() => {
      return false
    })()
  )
}

export const checkOnlyDot = (str: any): boolean =>
  (str[0] === '.' && str.length === 1) || (str[0] === ',' && str.length === 1)

export const checkForEmpty = (str: any): boolean => str.length === 0

export const checkStartWithDot = (str: any): boolean =>
  str[0] === '.' && str.length > 1

export const checkStartWithZero = (str: any): boolean =>
  str[0] === '0' && str.length > 1

export const checkStartWithZeros = (str: any): any => {
  if (str[0] === '0' && str[1] !== '.' && str[1] === '0') {
    const q: string = '' + str.slice(1, str.length)
    return checkStartWithZeros(q)
  } else {
    return str
  }
}
export const checkForLengthAfterDot = (n: string, toFix: number) => {
  if (n.indexOf('.') !== -1) {
    if (n.split('.')[1].length < toFix) {
      return true
    }
    return false
  }
  return true
}
